import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUsersFilteredQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Users_Bool_Exp>;
}>;


export type GetUsersFilteredQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, first_name: string, last_name: string, email: string, phone_number?: string | null, profile_photo?: string | null, created_at?: any | null, last_seen?: any | null, is_admin?: boolean | null, role?: string | null, title?: string | null, workspace_id?: any | null, organization_id?: any | null, workspace?: { __typename?: 'workspaces', id: any, logo?: string | null, name: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, user_properties: Array<{ __typename?: 'user_properties', id: any, user_id: string, property_id: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null } | null }>, user_organizations: Array<{ __typename?: 'organizations_users', id: any, organization_id: any, user_id: string, created_at?: any | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null }> }> };


export const GetUsersFilteredDocument = gql`
    query getUsersFiltered($where: users_bool_exp) {
  users(where: $where, order_by: {first_name: asc}) {
    id
    first_name
    last_name
    email
    phone_number
    profile_photo
    created_at
    last_seen
    is_admin
    role
    title
    workspace_id
    workspace {
      id
      logo
      name
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
    }
    user_properties {
      id
      user_id
      property_id
      property {
        id
        name
        address
        address_id
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
          country
        }
        organization {
          id
          name
          type
          organizationImageURL
        }
      }
    }
    user_organizations {
      id
      organization_id
      user_id
      created_at
      organization {
        id
        name
        type
        organizationImageURL
      }
    }
  }
}
    `;

/**
 * __useGetUsersFilteredQuery__
 *
 * To run a query within a React component, call `useGetUsersFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersFilteredQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUsersFilteredQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersFilteredQuery, GetUsersFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersFilteredQuery, GetUsersFilteredQueryVariables>(GetUsersFilteredDocument, options);
      }
export function useGetUsersFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersFilteredQuery, GetUsersFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersFilteredQuery, GetUsersFilteredQueryVariables>(GetUsersFilteredDocument, options);
        }
export function useGetUsersFilteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersFilteredQuery, GetUsersFilteredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersFilteredQuery, GetUsersFilteredQueryVariables>(GetUsersFilteredDocument, options);
        }
export type GetUsersFilteredQueryHookResult = ReturnType<typeof useGetUsersFilteredQuery>;
export type GetUsersFilteredLazyQueryHookResult = ReturnType<typeof useGetUsersFilteredLazyQuery>;
export type GetUsersFilteredSuspenseQueryHookResult = ReturnType<typeof useGetUsersFilteredSuspenseQuery>;
export type GetUsersFilteredQueryResult = Apollo.QueryResult<GetUsersFilteredQuery, GetUsersFilteredQueryVariables>;